import BillingsOrderCargoRailyAddRequest, {
  BillingsOrderCargoRailyAddRequestBody,
} from "./billings-order-cargo-raily-add.request";

const create = (
  request: BillingsOrderCargoRailyAddRequest,
): BillingsOrderCargoRailyAddRequestBody => {
  return {
    billingNodes: request.billingNodes,
    discount: request.discount,
  };
};

const billingsOrderCargoRailyAddRequestFactory = { create };

export default billingsOrderCargoRailyAddRequestFactory;
